import _ from 'underscore';
import URI from 'urijs';

export const URL_PROTOCOL_OPTIONS = [
  { key: 'https', text: 'https://' },
  { key: 'http', text: 'http://' },
];

export const DEFAULT_URL_PROTOCOL = 'https';

export const getValidProtocol = (protocol) => {
  const protocolOptionsKeys = _.pluck(URL_PROTOCOL_OPTIONS, 'key');
  return _.contains(protocolOptionsKeys, protocol) ? protocol : DEFAULT_URL_PROTOCOL;
};

export const getWebsiteByParts = (website) => {
  const uri = new URI(website);
  const protocol = getValidProtocol(uri.protocol());
  const protocolRegex = new RegExp(`${protocol}://`, 'g');
  const websiteWithoutProtocol = website.replace(protocolRegex, '') || '';
  return { protocol, websiteWithoutProtocol };
};

export const getWebsiteWithProtocol = (website, protocol) => {
  const { websiteWithoutProtocol } = getWebsiteByParts(website);
  const validProtocol = getValidProtocol(protocol);
  return `${validProtocol}://${websiteWithoutProtocol}`;
};

// By default use https as protocol
export function getUrlWithProtocol(website) {
  if (!website) {
    return '';
  }

  const site = website.trim();
  const uri = new URI(site);

  if (uri.protocol()) {
    return uri.toString().replace(/\/$/g, '');
  }

  return URI(site).protocol('https').toString().replace(/\/$/g, '');
}

export function getIsWebsiteChanged(oldWebsite, newWebsite) {
  const formatUrl = (url) => {
    let newUrl = (url || '').toLowerCase().trim();
    if (newUrl[newUrl.length - 1] === '/') {
      newUrl = newUrl.substring(0, newUrl.length - 1);
    }
    return newUrl.replace(/^https?:\/\//, '');
  };

  const oldUrl = formatUrl(oldWebsite);
  const newUrl = formatUrl(newWebsite);

  return oldUrl !== newUrl;
}
